"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOCAL_STORE_JWT = "chim_jwt";

exports.LOCAL_STORE_JWT = LOCAL_STORE_JWT;